<template>
  <div v-if="isNewPackage || isMediqSelect" class="product-flag-labels">
    <span v-if="isNewPackage" class="product-flag-label product-flag-label--new-package">Nieuwe verpakking</span>
    <VTooltip
      v-if="isMediqSelect"
      placement="top"
      :triggers="['hover', 'focus']"
      :popperTriggers="['hover', 'focus']"
      :delay="{ show: 100, hide: 2000 }"
      popper-class="mediq-select-tooltip"
    >
      <span class="product-flag-label product-flag-label--mediq-select" @click.stop>Mediq Select</span>
      <template #popper>
        {{ MEDIQ_SELECT_INFO_TEXT }}
        <a
          :href="MEDIQ_SELECT_INFO_URL"
          target="_blank"
          rel="noopener noreferrer"
          class="mediq-select-tooltip__link"
          @click.stop
        >
          Lees meer
        </a>
      </template>
    </VTooltip>
  </div>
</template>

<script>
import { Tooltip as VTooltip } from 'floating-vue';
import { MEDIQ_SELECT_INFO_TEXT, MEDIQ_SELECT_INFO_URL } from '@/constants/mediqSelect';

export default {
  name: 'ProductFlagLabels',
  components: {
    VTooltip
  },
  props: {
    isNewPackage: {
      type: Boolean,
      default: false
    },
    isMediqSelect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      MEDIQ_SELECT_INFO_TEXT,
      MEDIQ_SELECT_INFO_URL
    };
  }
};
</script>

<style lang="scss" scoped>
.product-flag-labels {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.25rem;

  :deep(.v-popper) {
    display: inline-flex;
  }
}

.product-flag-label {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  border-radius: 0.25rem;
  padding: 0.125rem 0.375rem;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.25;
  white-space: nowrap;

  &--new-package {
    background-color: $petrol-600;
    color: $white;
    border: 1px solid $petrol-600;
  }

  &--mediq-select {
    cursor: help;
    background-color: $white;
    color: $petrol-700;
    fill: $petrol-700;
    border: 1px solid $petrol-750;
  }
}
</style>
